<template>
  <div class="details">
    <div >
      <QS-h3-title >
        <template slot="title">应付详情</template>
      </QS-h3-title>
    </div>
    <div class="splitline mt16 mb16" />
    <div>
      <QS-h4-title title="应付信息详情" />
      <column-box
        :source="source"
        :list="basisList"
        :column="3"
        :label-width="130"
      ></column-box>
    </div>
    <div>
      <QS-h4-title title="应付业务信息" />
      <column-box
        :source="source"
        :list="businessList"
        :column="3"
        :label-width="130"
      ></column-box>
    </div>
  </div>
</template>

<script>
// eslint-disable-next-line import/no-cycle
import { getSensitivePaymentDetails } from '@/api/financeApi'
import selectOption from '@/store/dict/selectOptionDict'
import { mapState } from 'vuex'

export default {
  data() {
    return {
      basisList: [
        {
          key: 'id',
          name: '应付ID',
        },
        {
          key: 'payState',
          name: '付款状态',
        },
        {
          key: 'payType',
          name: '付款内容',
        },
        {
          key: 'gmtCreate',
          name: '创建时间',
        },
        {
          key: 'completeTime',
          name: '完成时间',
        },
        {
          key: 'closeTime',
          name: '关闭时间',
        },
        {
          key: 'payAmount',
          name: '应付金额',
        },
        {
          key: 'paidAmount',
          name: '已付金额',
        },
        {
          key: 'payDate',
          name: '应付日期',
        },
      ],
      businessList: [
        {
          key: 'sourceOrderId',
          name: '来源单ID',
        },
        {
          key: 'sourceOrderType',
          name: '来源类型',
        },
        {
          key: 'plateNo',
          name: '车牌号',
        },
        {
          key: 'payeeType',
          name: '收款方类型',
        },
        {
          key: 'payee',
          name: '收款方',
        },
        {
          key: 'payeeId',
          name: '收款方ID',
        },
        {
          key: 'purchaseType',
          name: '采购方式',
        },
        {
          key: 'remarks',
          name: '备注',
          alone: true,
        },
      ],
      source: {},
    }
  },
  computed: {
    ...mapState({
      freeTypeList: (state) => state.global.freeTypeList, // 收款项
    }),
  },
  created() {
    this.$store.dispatch('getPaymentMethods', { type: 'financeFeeType' }) // 获取收款项
    const { id } = this.$route.query
    this.getPaymentDetails(id)
  },
  methods: {
    getPaymentDetails(id) {
      getSensitivePaymentDetails({ id }).then((res) => {
        const { code, data } = res
        if (code === 1) {
          this.source = {
            ...data,
            payAmount: this.numberWithCommas(data.payAmount), // 应付金额
            paidAmount: this.numberWithCommas(data.paidAmount), // 已付金额
          }
          this.source.payState = selectOption.paymentStatusDict[data.payState]
          this.source.payType = this.formatEnumeration(this.freeTypeList)[data.payType]
          this.source.payeeType = selectOption.customerTypeDict[data.payeeType]
          this.source.sourceOrderType = selectOption.sourceOrderTypeDict[data.sourceOrderType]
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>

</style>
